<template>
    <div class="container-data-query">
      <form class="content-form-options" autocomplete="off">
        <div class="container-content">
          <div class="super-group-content-list">
            <div class="content-list">
              <div class="item-list" @change="valideEndMovements('1')">
                <label class="container-label" for="statusCheckBox[0]">
                  <span class="text-item">Últimos movimientos</span>
                  <input type="checkbox" name="statusCheckBox[0]" v-model="statusCheckBox[0]"
                    id="statusCheckBox[0]" :checked="statusCheckBox[0]" />
                  <span class="check-custom"></span>
                </label>
              </div>
              <div class="item-list" @change="valideEndMovements('2')">
                <label class="container-label" for="statusCheckBox[1]">
                  <span class="text-item">Ultimo estado de cuenta</span>
                  <input type="checkbox" name="statusCheckBox[1]" v-model="statusCheckBox[1]"
                    id="statusCheckBox[1]" :checked="statusCheckBox[1]" />
                  <span class="check-custom"></span>
                </label>
              </div>
              <div class="item-list" @change="valideEndMovements('3')">
                <label class="container-label" for="statusCheckBox[2]">
                  <span class="text-item">Estado de cuenta anteriores</span>
                  <input type="checkbox" name="statusCheckBox[2]" v-model="statusCheckBox[2]"
                    id="statusCheckBox[2]" :checked="statusCheckBox[2]" />
                  <span class="check-custom"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="container-options">
            <div class="container-content-options">
              <label for="s" class="label-content-select">
                <select name="s" id="s" class="select-custom" v-model="selectedOpt"
                  :disabled="statusSelect" @change="selectPeriod($event)">
                  <option value="" :selected="showDefault">{{ optionDefault }}</option>
                  <option :value="item" v-for="item of periodosList" :key="item" required>
                    {{ item.mes }} / {{ item.anio }}
                  </option>
                </select>
              </label>
              <div class="container-small">
                <small style="font-size: 12px;">Selecciona el periodo del estado de cuenta</small>
              </div>
            </div>
          </div>
        </div>
        <AlertView :modelAvise="modelAvise" />
        <div class="container-btns">
          <div class="container-size-btn">
            <button class="btn-gray success-btn" type="button" @click='goToBack'>
              <span class="btn-text-gray">
                <img src="@/assets/icons/arrowBefore.png" alt="bienestar-regresa" class="arrow-left" />
                Regresar
              </span>
            </button>
          </div>
          <div class="container-size-btn">
            <button class="btn-gray" type="button" @click="continuity"
              :class="{ 'success-btn': ctrlNext, 'error-btn': !ctrlNext }">
              <span class="btn-text-gray">
                Siguiente
                <img src="@/assets/icons/arrowRight.png" alt="bienestar-siguiente" class="arrow-right" />
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import AlertView from '@/core/components/AlertView.vue';
import useUtils from '@/core/utils/utils';

const props = defineProps({
  responsePeriodos: {
    type: Array,
  },
});

const statusCheckBox = ref([true, null, null]);
const statusSelect = ref(true);
const ctrlNext = ref(true);
const optionDefault = ref('Elige un periodo');
const showDefault = ref(true);
const selectedOpt = ref('');
const periodosList = ref([]);
const ctrlOption = ref('1');
const controlPeriodo = ref(0);
const modelAvise = {
  type: 'info',
  text: 'El estado de cuenta y los movimientos se enviaran al correo electrónico que ingresaste.',
};

const emits = defineEmits(['eventEmitBack', 'eventEmit']);

onMounted(() => {
  periodosList.value = props.responsePeriodos;
});

const longPeriodos = computed(() => (periodosList.value.length - 1));

const goToBack = () => {
  emits('eventEmitBack', true);
};

async function continuity() {
  let controlOption = '1';
  controlPeriodo.value += 1;
  if ((ctrlNext.value) && (controlPeriodo.value === 1)) {
    const formatPeriodo = ref('');
    if (ctrlOption.value === '2') {
      controlOption = '2';
      const select = periodosList.value[longPeriodos.value];
      formatPeriodo.value = `${select?.anio.substring(2, select?.anio.length)}-${useUtils.monthToNumber(select?.mes)}`;
    } else if (ctrlOption.value === '3') {
      controlOption = '2';
      const periodos = selectedOpt.value;
      const anioCorto = periodos?.anio.substring(2, periodos?.anio.length)
      const mesNum = useUtils.monthToNumber(periodos?.mes)
      formatPeriodo.value = `${anioCorto}-${mesNum}`;
    }
    const modelData = {
      tipoConsulta: Number(controlOption),
      periodo: formatPeriodo.value,
    };
    const emitValues = {
      continueFlow: true,
      data: modelData,
      componentName: 'rvfszpqu',
    };
    emits('eventEmit', emitValues);
    controlPeriodo.value = 0;
  }
}

function valideEndMovements(opc) {
  ctrlOption.value = opc;
  switch (opc) {
    case '1':
      showDefault.value = true;
      statusCheckBox.value[0] = true;
      statusCheckBox.value[1] = false;
      statusCheckBox.value[2] = false;
      statusSelect.value = true;
      ctrlNext.value = true;
      selectedOpt.value = '';
      break;
    case '2':
      showDefault.value = true;
      statusCheckBox.value[1] = true;
      statusCheckBox.value[0] = false;
      statusCheckBox.value[2] = false;
      statusSelect.value = true;
      ctrlNext.value = true;
      selectedOpt.value = '';
      break;
    case '3':
      statusCheckBox.value[2] = true;
      statusCheckBox.value[1] = false;
      statusCheckBox.value[0] = false;
      statusSelect.value = false;
      ctrlNext.value = false;
      break;
    default:
      ctrlOption.value = '';
      break;
  }
  return opc;
}

function selectPeriod(ev) {
  showDefault.value = false;
  if ((ev.target.value !== '') && (ev.target.value !== null)
    && (selectedOpt.value !== '') && (selectedOpt.value !== null)) {
    ctrlNext.value = true;
  } else {
    ctrlNext.value = false;
  }
}
</script>

<style scoped>

.container-data-query {
  width: 80%;
  margin: auto;
  padding-top: 40px;
}
.content-form-options {
  width: 90%;
  margin: auto;
}
.container-content {
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 120px;
}
.super-group-content-list {
  width: 55%;
  padding: 10px;
}
.item-list {
  display: flex;
  cursor: pointer;
  margin-bottom: 20px;
}
.container-list-left {
  width: 30%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.container-options {
  width: 45%;
  padding: 10px;
  margin-top: auto;
}
.container-small {
  width: 80%;
  margin: auto;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}
.container-content-options {
  margin: auto;
  text-align: center;
}
.label-content-select {
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-custom {
  width: 80%;
  height: 52px;
  appearance: none;
  outline: none;
  background-image: url("@/assets/icons/arrow-bottom.png");
  background-repeat: no-repeat;
  background-position: right 2rem top 50%;
  background-size: 1rem auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 40px;
  box-shadow: 2px 2px 19px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px rgba(32, 33, 36, 0.2);
  background-color: #fff;
  border-radius: 10px;
  cursor: pointer;
  font-size: 20px;
  font-family: Arial, sans-serif;
}
.container-text-item-left {
  margin-left: 50px;
  text-align: left;
  width: 70%;
}
.container-text-item-left span { font-size: 20px; }
.container-btns {
  display: flex;
  justify-content: center;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 20px;
}
.container-size-btn { width: 50%; }
.btn-gray {
  background-color: #979797;
  width: 55%;
  height: 50px;
  border-radius: 10px;
}
.btn-text-gray {
  display: flex;
  justify-content: center;
  align-items: center;
}
.success-btn { background-color: #0c825e; cursor: pointer; }
.error-btn   { background-color: #979797; cursor: auto; }
button {
  color: white;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 10px;
  outline: none;
  border: none;
  cursor: pointer;
  padding: 0px 10px;
}
.arrow-right { width: 20px; margin-left: 10px; }
.arrow-left  { width: 20px; margin-right: 10px; }
.container-label {
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  align-items: center;
  display: flex;
  height: 25px;
  width: 100%;
  justify-content: flex-start;
  margin: auto;
}
.container-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.check-custom {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 7px;
}
.container-label input:checked ~ .check-custom { background-color: #17a54d; }
.check-custom:after { content: ""; position: absolute; display: none; }
.container-label input:checked ~ .check-custom:after { display: block; }
.container-label .check-custom:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.text-item {
  position: absolute;
  left: 75px;
  font-size: 20px;
  text-align: justify;
}

/* ── Móvil ───────────────────────────────────────────────────── */
@media only screen and (min-width: 200px) and (max-width: 530px) {
  .container-data-query {
    width: 80%;
    display: flex;
    margin-top: 0;
    padding-top: 20px;
  }
  .content-form-options { width: 100%; margin: auto; display: table-caption; }
  .container-content { display: grid; justify-content: inherit; margin-bottom: 50px; }
  .container-content > * { order: 0; margin: 0; }
  .super-group-content-list { order: 0; padding: 0; width: 100%; }
  .item-list { display: flex; margin-bottom: 20px; }
  .container-list-left {
    width: 20%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .container-options { width: 100%; padding: 0; }
  .container-small { width: 100%; }
  .container-content-options { margin: auto; text-align: center; }
  .label-content-select { display: flex; justify-content: center; align-items: center; }
  .select-custom { font-size: 14px; height: 40px; width: 100%; }
  small { width: 100%; font-size: 12px; }
  .container-text-item-left { margin-left: 0; text-align: left; width: 70%; }
  .container-text-item-left span { font-size: 16px; }
  .container-btns {
    display: flex;
    justify-content: center;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .container-size-btn { width: 50%; }
  .btn-gray { width: 90%; height: 50px; border-radius: 10px; }
  .btn-text-gray { display: flex; justify-content: center; align-items: center; }
  .text-item { font-size: 14px; }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container-data-query {
    width: 90%;
    padding-top: 30px;
  }
  .content-form-options {
    width: 95%;
  }
  .container-content {
    margin-bottom: 60px;
  }
  .super-group-content-list {
    width: 50%;
    padding: 15px;
  }
  .container-options {
    width: 50%;
    padding: 15px;
  }
  .select-custom {
    width: 90%;
    font-size: 18px;
    height: 50px;
  }
  .container-small {
    width: 90%;
  }
  .text-item {
    font-size: 18px;
  }
  .container-label {
    font-size: 18px;
  }
  .btn-gray {
    width: 75%;
    height: 52px;
  }
  .btn-text-gray {
    font-size: 15px;
  }
}

@media only screen and (min-width: 350px) and (max-width: 400px) {
  .container-data-query { margin-top: 50px; }
  .text-item { font-size: 14px; }
}

@media only screen and (min-width: 300px) and (max-width: 330px) and (orientation: portrait) {
  .container-data-query { margin-top: 50px; }
  .text-item { font-size: 14px; }
}

@media only screen and (min-width: 530px) and (max-width: 960px) and (orientation: portrait) {
  .container-data-query { margin-top: 50px; }
  .item-list { margin-bottom: 40px; }
  .text-item { left: 40px; }
}

@media only screen
  and (min-width: 567px)
  and (max-width: 1025px)
  and (min-height: 300px)
  and (max-height: 730px)
  and (orientation: landscape) {
  .select-custom {
    background-position: right 0.5rem top 50%;
    background-size: 1rem auto;
    font-size: 16px;
    height: 50px;
    width: 100%;
  }
  .container-small { width: 100%; }
  .container-text-item-left { margin-left: 0; }
  .container-text-item-left span { font-size: 16px; }
  .container-list-left { justify-content: center; align-items: center; }
  .container-content { margin-bottom: 30px; }
  .text-item { font-size: 14px; }
}

@media only screen
  and (min-width: 550px)
  and (max-width: 600px)
  and (min-height: 200px)
  and (max-height: 380px)
  and (orientation: landscape) {
  .text-item { font-size: 14px; }
}
</style>